import React, { useEffect, useState } from "react";
import { useVariantCopy } from "./useVariantCopy";
import { mainUrl } from "../../utils/variant";

// Appears once the hero CTA has scrolled out of view, so a visitor reading down
// the page always has the entry point to the funnel one tap away. Hidden while
// the hero button is still on screen, so the two never compete.
const StickyCta = () => {
  const L = useVariantCopy();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hero = document.querySelector("header");
    if (!hero) return;

    const evaluate = () => {
      const pricing = document.getElementById("pricing");
      const rect = pricing?.getBoundingClientRect();
      // The plan cards carry their own CTAs, so the sticky bar would just
      // compete with them while they're on screen.
      const pricingInView = !!rect && rect.top < window.innerHeight && rect.bottom > 0;
      // Show only after the hero has fully passed above the viewport.
      setVisible(hero.getBoundingClientRect().bottom < 0 && !pricingInView);
    };

    evaluate();
    window.addEventListener("scroll", evaluate, { passive: true });
    window.addEventListener("resize", evaluate);
    return () => {
      window.removeEventListener("scroll", evaluate);
      window.removeEventListener("resize", evaluate);
    };
  }, []);

  // Keep mounted so scroll listeners stay live; hide via CSS when the how-it-works
  // video modal is open (body.video-modal-open set by variant/HomeHeader).
  if (!visible) return null;

  return (
    <>
    <style>{`
      body.video-modal-open .variant-sticky-cta {
        display: none !important;
      }
    `}</style>
    <div
      className="variant-sticky-cta"
      aria-hidden={false}
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1040,
        padding: "0.75rem 1rem calc(0.75rem + env(safe-area-inset-bottom))",
        background: "rgba(255,255,255,0.94)",
        backdropFilter: "blur(8px)",
        borderTop: "1px solid #e3e8ee",
        boxShadow: "0 -4px 16px rgba(50,50,93,0.10)",
        transform: visible ? "translateY(0)" : "translateY(120%)",
        transition: "transform 0.25s ease",
        pointerEvents: visible ? "auto" : "none",
      }}
    >
      <a
        href={mainUrl("/pricing?from=sticky")}
        className="d-flex align-items-center justify-content-center gap-2 no-underline"
        style={{
          width: "100%",
          maxWidth: 420,
          margin: "0 auto",
          padding: "0.85rem 1.5rem",
          borderRadius: 12,
          fontSize: "1.05rem",
          fontWeight: 700,
          color: "#fff",
          background: "linear-gradient(135deg, #635bff 0%, #7c3aed 100%)",
          boxShadow: "0 6px 18px rgba(99, 91, 255, 0.35)",
        }}
      >
        {L.header.heroCta}
        <i className="fa-solid fa-arrow-right" style={{ fontSize: "0.85rem" }}></i>
      </a>
    </div>
    </>
  );
};

export default StickyCta;
